import axios from 'axios';
import API_BASE_URL from '../config.js';

const getSearch = async (data) => {
    if (data.tag){

        const response = await axios.post(`${API_BASE_URL}/search/?city=${data.city}&tag=${data.tag}`, data);
        return response.data;
    }
    else{
        const response = await axios.post(`${API_BASE_URL}/search/`, data);

        return response.data;
    }

};

export default getSearch;
